module.exports = __webpack_public_path__ + "public/img/img.bc5bca4f.png";